import React from 'react';
import { CTAButton, CTA_SUBLABEL } from './CTAButton';
export function FinalCTA() {
  return <section className="w-full bg-teal-700 px-4 py-14 sm:py-20" data-id="element-90" data-mp="3ucx4nhgtzr09">
      <div className="mx-auto w-full max-w-xl text-center" data-id="element-91" data-mp="3ueqdn3ex2nbf">
        <h2 className="font-display text-[28px] font-black leading-tight text-white sm:text-4xl" data-id="element-92" data-mp="c7k3psj52dm8">
          Ready to prescribe GLP-1 with real confidence?
        </h2>
        <p className="mx-auto mt-3 max-w-md text-[15px] leading-relaxed text-white/80 sm:text-base" data-id="element-93" data-mp="m4f1g97l89zg">
          6 clinical volumes · 300+ protocols · 5 bonuses worth $275 — for a one-time $27.
        </p>
        <div className="mx-auto mt-7 max-w-md" data-id="element-94" data-mp="vv9srrzoxzrr">
          <CTAButton label="Get the Pathway for $27" variant="light" data-id="element-95" data-mp="vtypdta5qu16" />
          <p className="mt-3 text-center text-[11px] font-medium leading-relaxed text-white/70 sm:text-xs" data-id="element-96" data-mp="qwztp6auif0v">
            {CTA_SUBLABEL} · Automatic currency conversion
          </p>
        </div>
      </div>
    </section>;
}
export function Footer() {
  return <footer className="w-full bg-navy-900 px-4 pb-28 pt-10 text-center sm:pb-32" data-id="element-97" data-mp="2c4woipnd6ehx">
      <p className="font-display text-lg font-black tracking-tight text-white" data-id="element-98" data-mp="2c70xvn4185pl">
        🏥 DR. KARITO
      </p>
      <p className="mt-2 text-[12px] text-white/50" data-id="element-99" data-mp="2m3416wameae4">www.drakarito.com</p>
      <nav className="mt-4 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-[12px] font-medium text-white/60" aria-label="Footer" data-id="element-100" data-mp="2m4xc4ns9ngrx">
        <a href="#" className="hover:text-teal-400" data-id="element-101" data-mp="2v2r5bpuqhuav">
          Terms
        </a>
        <a href="#" className="hover:text-teal-400" data-id="element-102" data-mp="301u1slwnes78">
          Privacy
        </a>
        <a href="#" className="hover:text-teal-400" data-id="element-103" data-mp="34sshpkdq5o9y">
          Contact
        </a>
      </nav>
      <p className="mt-5 text-[11px] leading-relaxed text-white/35" data-id="element-104" data-mp="39s5eoxyb8bq9">
        © 2025 Dr. Karito — All rights reserved. This material is educational and does not replace
        professional clinical judgment.
      </p>
    </footer>;
}